'use client';

import type { AdjustableContactFormResolved } from './types';
import { AdjustableContactFormWithConfirmation } from '@/components/form/AdjustableContactFormWithConfirmation';

/*
 * The form measure (70.14-Widget-Width § 5): narrower than the page on
 * purpose, because a form is read and filled rather than scanned — see
 * 10.03.04.01, which treats the form container width as its own property.
 * Only the measure; the gutter comes from the SlotRenderer wrapper.
 */
const containerClassName = 'mx-auto max-w-4xl pt-4';

export function AdjustableContactFormWidgetComponent({
  resolved,
}: {
  resolved: AdjustableContactFormResolved;
}) {
  return (
    <div className={containerClassName}>
      <AdjustableContactFormWithConfirmation
        resolved={resolved}
        formClassName="mx-auto"
      />
    </div>
  );
}
